export type SafeBroadcastChannel = Pick<BroadcastChannel, 'postMessage' | 'addEventListener' | 'removeEventListener'>;

export function createSafeBroadcastChannel(name: string): SafeBroadcastChannel | undefined {
  try {
    if (typeof BroadcastChannel === 'undefined') {
      return undefined;
    }
    return new BroadcastChannel(name);
  } catch {
    return undefined;
  }
}
